import styled from 'styled-components';
import View from '@sdk/components/primitives/View';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';

export const LoaderContainer = styled(View)`
  ${FlexCenteredStyle}
`;
